export default "__VITE_ASSET__9f0c657d__"